/**
 * Jersey framing upsell on cart — toggle adds/removes $20 fee line item.
 */
(function () {
  function getUpsell() {
    return document.querySelector('[data-psm-framed-upsell]');
  }

  function setBusy(el, on) {
    if (el) el.classList.toggle('is-busy', on);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function addFramed(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: { _psm_jersey_framing: '1' },
          },
        ],
      }),
    }).then(function (r) {
      if (!r.ok) throw new Error('Add framing failed');
      return r.json();
    });
  }

  function removeFramed(lineKey, variantId) {
    if (lineKey) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
      }).then(function (r) {
        if (!r.ok) throw new Error('Remove framing failed');
        return r.json();
      });
    }
    return fetchCart().then(function (cart) {
      var line = (cart.items || []).find(function (item) {
        return String(item.variant_id) === String(variantId);
      });
      if (!line) return cart;
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 }),
      }).then(function (r) {
        if (!r.ok) throw new Error('Remove framing failed');
        return r.json();
      });
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updateSummaryFromCart(cart, variantId) {
    var framedItem = (cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId);
    });
    var framedLine = document.querySelector('.js-psm-framed-line');
    var itemsSubtotalLine = document.querySelector('.js-psm-items-subtotal');
    var mainSubtotal = document.querySelector('.js-cart_subtotal .money');

    if (framedItem) {
      if (framedLine) framedLine.hidden = false;
      if (itemsSubtotalLine) itemsSubtotalLine.hidden = false;
      if (framedLine) {
        var framedMoney = framedLine.querySelector('.money');
        if (framedMoney) framedMoney.textContent = formatMoney(framedItem.final_line_price);
      }
      if (itemsSubtotalLine) {
        var itemsMoney = itemsSubtotalLine.querySelector('.money');
        if (itemsMoney) {
          itemsMoney.textContent = formatMoney(cart.total_price - framedItem.final_line_price);
        }
      }
    } else {
      if (framedLine) framedLine.hidden = true;
      if (itemsSubtotalLine) itemsSubtotalLine.hidden = true;
    }

    if (mainSubtotal) {
      mainSubtotal.textContent = formatMoney(cart.total_price);
    }
  }

  function reloadCartSection(sectionId) {
    if (!sectionId) {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) {
          window.location.reload();
          return;
        }
        var wrap = document.querySelector('[data-psm-cart-page]');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-psm-cart-page]');
        if (wrap && incoming) {
          wrap.innerHTML = incoming.innerHTML;
          bind();
          if (window.psmCartTosBind) window.psmCartTosBind();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function onToggleChange(event) {
    var input = event.target;
    var upsell = getUpsell();
    if (!upsell || !upsell.contains(input)) return;

    var variantId = upsell.getAttribute('data-framed-variant-id');
    var lineKey = upsell.getAttribute('data-framed-line-key');
    var sectionId = upsell.getAttribute('data-section-id');
    if (!variantId) return;

    setBusy(upsell, true);

    var action = input.checked
      ? addFramed(variantId)
      : removeFramed(lineKey, variantId);

    action
      .then(function () {
        return reloadCartSection(sectionId);
      })
      .catch(function (err) {
        console.error('[psm-jersey-framed]', err);
        input.checked = !input.checked;
        alert('Unable to update framing option. Please try again.');
      })
      .finally(function () {
        setBusy(upsell, false);
      });
  }

  function bind() {
    var upsell = getUpsell();
    if (!upsell) return;
    var input = upsell.querySelector('[data-psm-framed-toggle]');
    if (!input || input.dataset.psmFramedBound === '1') return;
    input.dataset.psmFramedBound = '1';
    input.addEventListener('change', onToggleChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
